/*
https://blog.garstasio.com/you-dont-need-jquery/
http://blog.wearecolony.com/a-year-without-jquery/
http://youmightnotneedjquery.com/
https://plainjs.com/javascript/plugins/other/
https://github.com/eorroe/NodeList.js
https://blog.adtile.me/2014/01/16/a-dive-into-plain-javascript/
https://www.sitepoint.com/guide-vanilla-ajax-without-jquery/
https://www.sitepoint.com/dom-manipulation-vanilla-javascript-no-jquery/
https://www.npmjs.com/package/@59naga/babel-plugin-transform-array-from
https://stackoverflow.com/questions/32120943/babel-is-not-processing-array-from-or-for-of-loops#32120985
https://stackoverflow.com/questions/32120943/babel-is-not-processing-array-from-or-for-of-loops
https://babeljs.io/docs/plugins/preset-env/
*/

import "regenerator-runtime/runtime";
import jQuery from "jquery";

function dq(queryFn, sel, ctx) {
  "use strict";
  return typeof ctx == "string"
    ? document[queryFn].call(document, `${ctx} ${sel}`)
    : ctx[queryFn].call(ctx, sel);
}

export const $ = query;

export function query(sel, ctx = document) {
  return dq("querySelector", sel, ctx);
}

export const $$ = queryAll;

export function queryAll(sel, ctx = document) {
  return Array.prototype.slice.call(dq("querySelectorAll", sel, ctx));
}

export const udpateTabSticking = function () {
  "use strict";
  let shouldStick =
    Math.floor(jQuery("#menu-desktop")[0].getBoundingClientRect().top) < 0;
  let tabsStuck = jQuery(".tabs-outer .tabs-inner").hasClass(
    "fix frozen-width frozen-right",
  );

  if (shouldStick !== tabsStuck) {
    if (shouldStick) {
      jQuery(".tabs-outer .tabs-inner").addClass(
        "fix frozen-width frozen-right",
      );
    } else {
      jQuery(".tabs-outer .tabs-inner").removeClass(
        "fix frozen-width frozen-right",
      );
    }
  }
};

/**
 * Gets the portalurl and respect subsites
 */
export function getBaseUrl() {
  "use strict";
  let baseUrl =
    document.body.dataset.portalUrl + "/" + document.documentElement.lang;
  if (
    "baseSubsiteUrl" in document.body.dataset &&
    "subsiteMultilingual" in document.body.dataset
  ) {
    baseUrl =
      document.body.dataset.baseSubsiteUrl +
      "/" +
      document.documentElement.lang;
  } else if ("baseSubsiteUrl" in document.body.dataset) {
    baseUrl = document.body.dataset.baseSubsiteUrl;
  }
  return baseUrl;
}

export const checkStickyImage = async (baseUrl) => {
  /**
   * Fetch if the StickyLogo is set
   * @type {Response}
   */
  let imageHead = await fetch(baseUrl + "/@@images/sticky_logo", {
    method: "HEAD",
  });
  let imageHeadJson = await imageHead.ok;
  return imageHeadJson;
};

export function addSearchQuery() {
  let searchString = window.location.search;
  if (searchString) {
    let link = $(".pubdb-search");
    if (link) {
      link.href = link.href + searchString;
    }
  }
}

export function getPathFromUrl(url) {
  return url.split(/[?#]/)[0];
}
